<template>
  <div class="calico-credit-box-page">
    <div class="calico-credit-box-container">
      <h2 class="heading--xsmall">
        Credit Box Item
      </h2>
      <CalicoCreditBoxItem
        :label="label"
        :score="score"
        :value="value"
        :tooltip-header="tooltipHeader"
        :tooltip-label="tooltipLabel"
        :tooltip-body="tooltipBody"
      />

      <h2 class="heading--xsmall">
        Credit Box
      </h2>
      <CalicoCreditBox
        :items="creditBoxItems"
      />
    </div>
  </div>
</template>

<script>
import CalicoCreditBox from '@/components/pattern/creditBox/index.vue'
import CalicoCreditBoxItem from '@/components/calico/creditBoxItem/index.vue'
import { Tooltips } from '@/enums'


export default {
  name: 'CalicoCreditBoxPage',
  components: {
    CalicoCreditBoxItem,
    CalicoCreditBox
  },
  data() {
    return {
      label: Tooltips.CREDITBOX_DEBT_COVERAGE_HEADER,
      score: 1,
      value: Tooltips.CREDITBOX_DEFAULT_VALUE,
      tooltipHeader: Tooltips.CREDITBOX_DEBT_COVERAGE_HEADER,
      tooltipLabel: Tooltips.CREDITBOX_LABEL,
      tooltipBody: Tooltips.CREDITBOX_DEBT_COVERAGE_BODY,
      creditBoxItems: [
        {
          label: Tooltips.CREDITBOX_DEBT_COVERAGE_HEADER,
          score: 1,
          value: Tooltips.CREDITBOX_DEFAULT_VALUE,
          tooltipHeader: Tooltips.CREDITBOX_DEBT_COVERAGE_HEADER,
          tooltipLabel: Tooltips.CREDITBOX_LABEL,
          tooltipBody: Tooltips.CREDITBOX_DEBT_COVERAGE_BODY,
        },
        {
          label: Tooltips.CREDITBOX_PROFITABILITY_HEADER,
          score: 1,
          value: Tooltips.CREDITBOX_DEFAULT_VALUE,
          tooltipHeader: Tooltips.CREDITBOX_PROFITABILITY_HEADER,
          tooltipLabel: Tooltips.CREDITBOX_LABEL,
          tooltipBody:Tooltips.CREDITBOX_PROFITABILITY_BODY
        },
        {
          label: Tooltips.CREDITBOX_LIQUIDITY_HEADER,
          score: 1,
          value: Tooltips.CREDITBOX_DEFAULT_VALUE,
          tooltipHeader: Tooltips.CREDITBOX_LIQUIDITY_HEADER,
          tooltipLabel: Tooltips.CREDITBOX_LABEL,
          tooltipBody: Tooltips.CREDITBOX_LIQUIDITY_BODY
        },
        {
          label: Tooltips.CREDITBOX_LEVERAGE_HEADER,
          score: 1,
          value: Tooltips.CREDITBOX_DEFAULT_VALUE,
          tooltipHeader: Tooltips.CREDITBOX_LEVERAGE_HEADER,
          tooltipLabel: Tooltips.CREDITBOX_LABEL,
          tooltipBody: Tooltips.CREDITBOX_LEVERAGE_BODY
        },
        {
          label: Tooltips.CREDITBOX_CAPITAL_ADEQUACY_HEADER,
          score: 1,
          value: Tooltips.CREDITBOX_DEFAULT_VALUE,
          tooltipHeader: Tooltips.CREDITBOX_CAPITAL_ADEQUACY_HEADER,
          tooltipLabel: Tooltips.CREDITBOX_LABEL,
          tooltipBody: Tooltips.CREDITBOX_CAPITAL_ADEQUACY_BODY
        },
        {
          label: Tooltips.CREDITBOX_COLLATERAL_COVERAGE_HEADER,
          score: 1,
          value: Tooltips.CREDITBOX_DEFAULT_VALUE,
          tooltipHeader: Tooltips.CREDITBOX_COLLATERAL_COVERAGE_HEADER,
          tooltipLabel: Tooltips.CREDITBOX_LABEL,
          tooltipBody: Tooltips.CREDITBOX_COLLATERAL_COVERAGE_BODY
        },
        {
          label: Tooltips.CREDITBOX_GUARANTOR_STRENGTH_HEADER,
          score: 1,
          value: Tooltips.CREDITBOX_DEFAULT_VALUE,
          tooltipHeader: Tooltips.CREDITBOX_GUARANTOR_STRENGTH_HEADER,
          tooltipLabel: Tooltips.CREDITBOX_LABEL,
          tooltipBody: Tooltips.CREDITBOX_GUARANTOR_STRENGTH_BODY
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.calico-credit-box-page {
  .calico-credit-box-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
  }
}
</style>
